import { withGenericConfig } from "/contexts/generic-config-context";

import MediaItem from "../media-item/media-item-component";

import { componentStyles } from "./items-list.component.scss";

const ItemsList = ({ items, direction }) => {
  return (
    <div className="items-list-component">
      {items.map((item, index) =>
        <div className="item-wrapper" key={`item_${index}`}>
          <MediaItem direction={direction} {...item} />
        </div>
      )}
      <style jsx>{componentStyles}</style>
    </div>
  )
};

ItemsList.defaultProps = {
  direction: "row"
}

export default withGenericConfig(ItemsList);